const STEPS = ["available", "claimed", "scheduled", "completed"];
const LABELS = { available: "Available", claimed: "Claimed", scheduled: "Scheduled", completed: "Completed" };

export function StatusTimeline({ status }) {
  const idx = STEPS.indexOf(status);
  return (
    <div className="flex items-center gap-1" data-testid="status-timeline">
      {STEPS.map((s, i) => (
        <div key={s} className="flex items-center gap-1">
          <span className={`text-[11px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${i <= idx ? "bg-emerald-100 text-emerald-800" : "bg-stone-100 text-stone-400"}`}>{LABELS[s]}</span>
          {i < STEPS.length - 1 && <span className={`w-3 h-px ${i < idx ? "bg-emerald-300" : "bg-stone-200"}`} />}
        </div>
      ))}
    </div>
  );
}
